import { useState } from "react"
import { IRenda } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { Grid, TextField } from "@mui/material"
import { NumberFormatCustom } from "../../../../../../../utils"
// Icon

export const RecorteRendaAnual = () => {
    // Use State
    const [selectedRendaAnual, setSelectedRendaAnual] = useState<IRenda>({})
    // Hook
    const { setEditRecorteFormFiltros } = useRecortesExtracaoService()
   

    return (
        <>
            <Grid item xs={5.5} my={2} px={2}>
                <TextField
                    value={selectedRendaAnual.min ?? ''}
                    InputProps={{
                        startAdornment: <span style={{
                            marginRight: '5px'
                        }}>R$</span>,
                        inputComponent: NumberFormatCustom,
                    }}
                    onChange={(e) => {
                        const regexValue = e.target.value.replace(/\D/g, '')
                        const updatedMin = regexValue.length === 0 ? undefined : Number(regexValue)
                    
                        const updatedRenda = {
                            ...selectedRendaAnual,
                            min: updatedMin
                        }
                    
                        setSelectedRendaAnual(updatedRenda)
                    
                        // ✅ Atualiza o filtro global
                        setEditRecorteFormFiltros({
                            filtro: 'rendaPresumidaAnual',
                            value: updatedRenda
                        })
                    
                    }}
                    
                    label="Renda anual mínima"
                    fullWidth
                />
            </Grid>
            <Grid item xs={5.5} my={2} px={2}>
                <TextField
                    value={selectedRendaAnual.max ?? ''}
                    InputProps={{
                        startAdornment: <span style={{
                            marginRight: '5px'
                        }}>R$</span>,
                        inputComponent: NumberFormatCustom,
                    }}
                    onChange={(e) => {
                        const regexValue = e.target.value.replace(/\D/g, '')
                        const updatedMax = regexValue.length === 0 ? undefined : Number(regexValue)
                    
                        const updatedRenda = {
                            ...selectedRendaAnual,
                            max: updatedMax
                        }
                    
                        setSelectedRendaAnual(updatedRenda)
                    
                        // ✅ Atualiza o filtro global
                        setEditRecorteFormFiltros({
                            filtro: 'rendaPresumidaAnual',
                            value: updatedRenda
                        })
                    
                    }}
                    label="Renda anual máxima"
                    fullWidth
                />
            </Grid>
        </>
    )
}